import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CNUser } from 'src/app/models/cnuser';

@Component({
  selector: 'app-user-list-row',
  templateUrl: './user-list-row.component.html',
  styleUrls: ['./user-list-row.component.scss']
})
export class UserListRowComponent implements OnInit {

  @Input() mode = 'summary';
  @Input() actions = [];
  @Output() remove: EventEmitter<CNUser> = new EventEmitter();

  public userSexIcon = ['fas', 'genderless'];

  private theUser: CNUser;

  constructor() { }

  ngOnInit(): void {
    console.log('actions', this.actions);
  }

  @Input() set user(theUser: CNUser) {
    this.theUser = theUser;
    this.userSexIcon = this.theUser.sex.asFaIcon;
  }

  get user(): CNUser {
    return this.theUser;
  }

  show(action: string): boolean {
    return this.actions.includes(action);
  }

  removeUser(): void {
    this.remove.emit(this.user);
  }
}
